import styled from 'styled-components';

/**
 * @deprecated This component is deprecated and will be removed. Please utilise the columnBuilder instead.
 */
export const TableHeightRefWrapper = styled.div<{ disableHeightGrowth?: boolean }>`
	width: 100%;
	height: ${({ disableHeightGrowth }) => (disableHeightGrowth ? 'undefined' : '100%')};
	min-height: 0;
	max-height: 100%;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	flex: 1;
`;
